<h1 *ngIf="!mobile"
    mat-dialog-title>
    {{ 'default.externalUnitImport.importUnits' | blah }}
</h1>

<div *ngIf="initializing">
    <hpo-placeholder type="input"></hpo-placeholder>
    <hpo-placeholder type="input"></hpo-placeholder>
    <hpo-placeholder type="input"></hpo-placeholder>
    <hpo-placeholder type="input"
        [rows]="7"></hpo-placeholder>
    <hpo-placeholder type="row"></hpo-placeholder>
</div>

<div *ngIf="!initializing">

    <div class="form-container">

        <mat-form-field>
            <mat-label>{{ 'default.externalRequest.importTargetId' | blah }}</mat-label>
            <input matInput
                id="eui-import-target-id-input"
                type="text"
                [(ngModel)]="importTargetId"
                maxlength="500"
                required="true">
        </mat-form-field>

        <hpo-select title="{{ 'default.externalUnitImport.importTargetType' | blah }}"
            id="eui-import-target-type-select"
            [data]="importTargetTypes"
            searchBy="Value"
            [(selected)]="importTargetType"
            [isRequired]="true"
            [showTooltip]="true">
            <ng-template let-item>
                {{item.Value}}
            </ng-template>
        </hpo-select>

        <hpo-select title="{{ 'default.externalUnitImport.importPriceList' | blah }}"
            id="eui-import-pricelist-select"
            [data]="priceLists"
            searchBy="Name"
            [(selected)]="importPriceList"
            [isRequired]="true"
            [showTooltip]="true">
            <ng-template let-item>
                {{item.Name}}
            </ng-template>
        </hpo-select>

        <div class="checkbox-container">
            <div>{{ 'default.externalUnitImport.importUnitType' | blah }} *</div>

            <mat-hint *ngIf="targetType === 'Worksite' && !areAllImportUnitTypesNotSelectable">
                {{ 'default.externalUnitImport.selectionsCannotBeEdited' | blah }}
            </mat-hint>
            <mat-error *ngIf="areAllImportUnitTypesNotSelectable">
                {{ 'default.externalUnitImport.selectionsCannotBeMade' | blah }}:

                <ng-container *ngIf="targetType === 'Task'">
                    {{ 'default.externalUnitImport.seeInfosInCheckboxes' | blah | lowercase }}
                </ng-container>
                <ng-container *ngIf="targetType === 'Worksite'">
                    {{ 'default.externalUnitImport.targetBudgetLocked' | blah | lowercase }}
                </ng-container>
            </mat-error>

            <div *ngFor="let item of importUnitTypes">
                <mat-checkbox [id]="'eui-import-unit-type-' + item.type + '-checkbox'"
                    [(ngModel)]="item.checked"
                    [disabled]="isImportUnitTypeDisabled(item.type)"
                    matTooltip="{{ getImportUnitTypeTooltip(item.type) | blah }}"
                    matTooltipPosition="right"
                    matTooltipClass="hpo">
                    {{ 'default.externalUnitImport.importUnitTypes.' + item.type | blah }}
                </mat-checkbox>
            </div>
        </div>

    </div>

    <div class="history-container">

        <div>{{ 'default.externalRequest.requestHistory' | blah:[5] }}:</div>

        <div class="history-entries">

            <div *ngFor="let item of externalUnitImports">

                <ng-container [ngSwitch]="item.RequestState">
                    <mat-icon *ngSwitchCase="'InProgress'"
                        class="in-progress"
                        matTooltip="{{ 'default.externalRequest.requestInProgress' | blah }}"
                        matTooltipPosition="right"
                        matTooltipClass="hpo">refresh</mat-icon>
                    <mat-icon *ngSwitchCase="'Completed'"
                        class="completed"
                        matTooltip="{{ 'default.externalRequest.requestCompleted' | blah }}"
                        matTooltipPosition="right"
                        matTooltipClass="hpo">check_circle_outlined</mat-icon>
                    <mat-icon *ngSwitchCase="'Failed'"
                        class="failed"
                        matTooltip="{{ 'default.externalRequest.requestFailedWithCode' | blah:[item.RequestStatusCode || '-'] }}"
                        matTooltipPosition="right"
                        matTooltipClass="hpo">cancel_outlined</mat-icon>
                </ng-container>

                <div>
                    {{ item.RequestCreated | date:'d.M.yyyy H:mm' }},
                    {{item.RequesterName}}
                </div>

            </div>

            <i *ngIf="externalUnitImports.length === 0">
                {{ 'default.externalRequest.noPreviousRequests' | blah }}
            </i>

        </div>
    </div>

</div>

<mat-dialog-actions align="end">

    <button id="eui-cancel-button"
        mat-stroked-button
        mat-dialog-close>
        {{ 'default.cancel' | blah | uppercase }}
    </button>

    <button id="eui-submit-button"
        mat-stroked-button
        color="accent"
        [disabled]="initializing || submitting || !isFormValid"
        (click)="submit()">
        {{ 'default.sendRequest' | blah | uppercase }}
    </button>

</mat-dialog-actions>